<template>
  <div>
    <v-card-title>Value : {{ this.fromChild }}<br/>Increment : {{ this.counter }}</v-card-title>
    <v-card-text>
      <ChildComp
        :parentData="myData"
        v-on:childToParent="onChildClick"
        v-on:increment="counter++">
      </ChildComp>
    </v-card-text>
  </div>
</template>
<script>
import ChildComp from './ChildComp.vue';
export default {
  data () {
    return {
      counter: 0,
      fromChild: '', // This value is set to the value emitted by the child
    }
  },
  name: 'ParentComp',
  components: {
    ChildComp
  },
  methods: {
    // Triggered when `childToParent` event is emitted by the child.
    onChildClick (value) {
      this.fromChild = value
    }
  }
}
</script>